export default {
  styleOverrides: {
    root: {
      "&:hover": {
        //boxShadow: "0px 7px 10px rgba(0,0,0,0.15)"
      },
    },
  }
};
